module.exports = __webpack_public_path__ + "static/takoprint-28151665bd801a1701dcd83baf6f4e1e.png";